import { apiFetch, type TokenStore } from './client.ts';

/**
 * Notifications API client (spec §8 lines 1257+; Phase 8 backend).
 * All endpoints are recipient-scoped server-side (own notifications only) and
 * exempt from the subscription gate.
 */

export interface Notification {
  id: string;
  type: string;
  title: string;
  body: string | null;
  linkUrl: string | null;
  readAt: number | null;
  createdAt: number;
}

export interface NotificationListResponse {
  notifications: Notification[];
  nextCursor: number | null;
}

export async function listNotifications(
  store: TokenStore,
  opts: { unread?: boolean } = {},
): Promise<NotificationListResponse> {
  const qs = opts.unread ? '?unread=true' : '';
  return apiFetch<NotificationListResponse>(`/notifications${qs}`, {}, store);
}

export async function markAllNotificationsRead(store: TokenStore): Promise<{ count: number }> {
  return apiFetch<{ count: number }>(
    '/notifications/mark-all-read',
    { method: 'POST' },
    store,
  );
}

/** Dismiss every one of the user's own notifications already read (TF-0035). */
export async function dismissAllReadNotifications(store: TokenStore): Promise<{ count: number }> {
  return apiFetch<{ count: number }>(
    '/notifications/dismiss-all-read',
    { method: 'POST' },
    store,
  );
}

export async function markNotificationRead(id: string, store: TokenStore): Promise<void> {
  await apiFetch<Record<string, never>>(
    `/notifications/${encodeURIComponent(id)}/read`,
    { method: 'POST' },
    store,
  );
}

/** Dismiss one of the user's own notifications (V6 gap 17-A). */
export async function deleteNotification(id: string, store: TokenStore): Promise<void> {
  await apiFetch<Record<string, never>>(
    `/notifications/${encodeURIComponent(id)}`,
    { method: 'DELETE' },
    store,
  );
}
